import React from "react";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../images/logo.png";
import { WppButton } from "./chatButton";

const Footer = () => {
  return (
    <FooterWrapper>
      <Fade bottom>
        <FooterSection>
          <Link to={"/"}>
            <img src={logo} alt="LOGO" />
          </Link>
          <p>
            "A recuperação é um processo,
            <br />
            não um evento isolado."
          </p>
        </FooterSection>
      </Fade>
      <Fade bottom>
        <FooterSection>
          <h3>Tratamentos</h3>
          <div></div>
          <a href="https://api.whatsapp.com/send?phone=5511917721058&text=Olá%20Quero%20saber%20mais%20Sobre%20Clínica%20de%20Recuperação">
            <p>Tratamento para dependência química</p>
            <p>Tratamento para alcoolismo</p>
            <p>Tratamento para mulheres</p>
            <p>Tratamento para menores</p>
            <p>Internação voluntária</p>
            <p>Internação involuntária</p>
          </a>
        </FooterSection>
      </Fade>

      <Fade bottom>
        <FooterSection>
          <h3>Contatos</h3>
          <div></div>
          <p>suporte@grupomendeseherrero.com.br</p>
          <a href="https://api.whatsapp.com/send?phone=5511917721058&text=Olá%20Quero%20saber%20mais%20Sobre%20Clínica%20de%20Recuperação">
            <p>(11)917721058</p>
          </a>
          
        </FooterSection>
      </Fade>
      <FooterSection></FooterSection>
    </FooterWrapper>
  );
};

export default Footer;

const FooterWrapper = styled.footer`
  filter: drop-shadow(0px 1px 5px #3a3a3a);
  background-color: #6e97ff;
  color: black;
  display: flex;
  justify-content: space-evenly;
  padding: 1rem;
  width: 100%;
  min-height: 250px;
  height: auto;
  font-family: "Jost", sans-serif;
  padding-left: 20%;
  padding-top: 35px;
  padding-bottom: 30px;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    height: auto;
    padding: 0.4rem;
  }
`;

const FooterSection = styled.div`
  flex-basis: 30%;
  text-align: left;
  a {
    text-decoration: none;
  }
  h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #012372;
  }
  div {
    width: 60px;
    height: 2px;
    background-color: #4879ed;
    margin-bottom: 15px;
    margin-top: 10px;
  }
  p {
    margin-bottom: 0.5rem;
    color: #000000;
    line-height: 1.2rem;
  }
  img {
    width: 200px;
    margin-bottom: 18px;
  }
  @media (max-width: 900px) {
    h3 {
      font-size: 0.8rem;
      margin-bottom: 0.5rem;
    }
    p {
      font-size: 0.8rem;
      margin-bottom: 0.1rem;
    }
  }
`;
